<template>
  <kst-section collapsible collapsed 
    :title="title"
    :help-collapsed="sectionHelp_Collapsed"
  >
    <ItemSearchList
      @init="handleItem_Init"
      @submit="handleItem_Submit"
    />

    <kst-output control-off status-off
      field="RefID" :data="userData" :catalog="Catalog"
    >
      <template #right>
        <div class="control">
          <template v-if="userData.RefID === null">
            <kst-tooltip search-mode hover-only :content="Model.Module.FullName">
              <kst-button search-mode @click="handleSearch"/>
            </kst-tooltip>
          </template>
          <template v-else>
            <kst-tooltip clear-mode hover-only :content="Model.Module.FullName">
              <kst-button clear-mode @click="handleClear"/>
            </kst-tooltip>
          </template>
        </div>
      </template>
    </kst-output>
  </kst-section>
</template>

<script>
import Catalog from "../ItemCatalog.js";
import Info from "../ItemInfo.js";
import Model from "../ItemModel.js";
import Services from "../../../services/Api/ItemServices.js";

import ItemSearchList from "../SearchList/ItemScL.vue";

export default {
  components: {
    ItemSearchList
  },
  props: {
    userData: Object
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model,
    // func
    showItemFunc: null
  }),
  computed: {
    title() {
      return Info.Section.Ref.Title;
    },
    sectionHelp_Collapsed() {
      return Model.getRefSectionHelp(this.userData);
    }
  },
  methods: {
    /*** by item modal ***/

    handleItem_Init(show) {
      this.showItemFunc = show;
    },
    handleItem_Submit(itemData) {
      Model.setDetailsByRef(this.userData, itemData);
    },

    /*** custom ***/

    handleSearch() {
      this.showItemFunc(
        Services.getRelatedItemList
      );
    },
    handleClear() {
      Model.clearDetailsByRef(this.userData);
    }
  }
}
</script>